module.exports = __webpack_public_path__ + "img/icon_3.7193165d.png";